import type { CatalogDefinitionSnapshot } from './types';

/** Presentation-safe navigation view derived entirely from the active snapshot. */
export interface CatalogNavigationSubcategory {
  id: string;
  nameFa: string;
  nameEn: string;
}

export interface CatalogNavigationFamily {
  id: string;
  nameFa: string;
  nameEn: string;
  /** Canonical family ID doubles as the icon key for CategoryIcon. */
  icon: string;
  subcategories: CatalogNavigationSubcategory[];
}

export function getCatalogNavigationFamilies(snapshot: Readonly<CatalogDefinitionSnapshot>): CatalogNavigationFamily[] {
  return snapshot.taxonomy
    .filter(category => category.level === 1)
    .map(family => ({
      id: family.id,
      nameFa: family.label.fa,
      nameEn: family.label.en,
      icon: family.id,
      subcategories: family.childIds.flatMap(childId => {
        const child = snapshot.taxonomy.find(category => category.id === childId);
        return child ? [{ id: child.id, nameFa: child.label.fa, nameEn: child.label.en }] : [];
      }),
    }));
}
